export const SaveFileIcon: React.FC = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 318" clipPath="url(#clip0_945_20343)">
      <g id="Group 107">
        <path
          id="Vector"
          d="M38.3977 12.1924C39.1682 10.2788 39.1471 8.13746 38.3388 6.23947C37.5306 4.34147 36.0015 2.84229 34.0879 2.07171C32.1743 1.30114 30.033 1.3223 28.135 2.13053C26.237 2.93877 24.7378 4.46788 23.9672 6.38147M28.277 6.38147L23.4346 6.38147L23.4346 1.53905"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M16.0415 5.84888V12.5166C16.0415 12.9587 16.2171 13.3827 16.5297 13.6953C16.8424 14.0079 17.2663 14.1836 17.7084 14.1836H24.3762"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M1.04053 20.8489V9.18221C1.04053 8.29816 1.39172 7.45031 2.01684 6.82519C2.64196 6.20007 3.48981 5.84888 4.37386 5.84888H16.0405L24.3739 14.1822V20.8489"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M1.04053 35.848H24.3739"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M1.04053 30.8485H24.3739"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M1.04053 25.849H24.3739"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_945_20343">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.5 -0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
)
